<template>
  <nav class="navbar">
    <router-link to="/" class="navbar-brand">
      <i class="fas fa-gift"></i>
      <span class="content-title text-uppercase ml-10">GiftSift</span>
    </router-link>
    <div class="navbar-content ml-auto"></div>
    <ul class="navbar-nav ml-auto d-none d-md-flex">
      <li v-for="menuItem in menu" :key="menuItem.text" class="nav-item">
        <router-link :to="menuItem.link" class="nav-link">{{
          menuItem.text
        }}</router-link>
      </li>
      <li v-if="isAuthenticated" class="nav-item">
        <a id="logout" v-on:click="logout" href="#" class="nav-link">
          Logout
        </a>
      </li>
      <router-link v-if="!isAuthenticated" class="btn btn-primary" to="/events"
        >Login</router-link
      >
      <button
        class="btn btn-action ml-5"
        type="button"
        onclick="halfmoon.toggleDarkMode()"
        aria-label="Toggle dark mode"
      >
        <i class="fa fa-moon-o" aria-hidden="true"></i>
      </button>
    </ul>
    <div class="navbar-content d-md-none ml-auto">
      <div class="dropdown with-arrow">
        <button
          class="btn"
          data-toggle="dropdown"
          type="button"
          id="navbar-dropdown-toggle-btn-1"
        >
          Menu
          <i class="fa fa-angle-down" aria-hidden="true"></i>
        </button>
        <div
          id="navDropdown"
          class="dropdown-menu dropdown-menu-right w-200"
          aria-labelledby="navbar-dropdown-toggle-btn-1"
          @click="closeMenu"
        >
          <div v-if="isAuthenticated">
            <router-link
              v-for="menuItem in menu"
              :key="menuItem.text"
              :to="menuItem.link"
              class="dropdown-item text-right"
              >{{ menuItem.text }}</router-link
            >
            <a
              v-if="isAuthenticated"
              id="logout"
              v-on:click="logout"
              href="#"
              class="dropdown-item text-right"
            >
              Logout
            </a>
          </div>
          <router-link
            v-if="!isAuthenticated"
            class="btn btn-primary text-right"
            to="/events"
            >Login</router-link
          >
          <button
            class="btn btn-action ml-5"
            type="button"
            onclick="halfmoon.toggleDarkMode()"
            aria-label="Toggle dark mode"
          >
            <i class="fa fa-moon-o" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { auth } from "../../lib/firebase.js";
export default {
  props: [],
  data() {
    return {
      isOpen: false,
      menu: [{ text: "Home", link: "/" }],
    };
  },
  mounted() {},
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    logout: async function() {
      auth.signOut().then(
        auth.onAuthStateChanged((user) => {
          if (user) {
            this.$store.commit("setAuthenticated", true);
            this.$store.commit("setUser", user);
          } else {
            this.$store.commit("setAuthenticated", false);
            this.$store.commit("setUser", null);
          }
          this.$router.go("/");
        })
      );
    },
    closeMenu: function() {
      const menu = document.getElementById("navDropdown");
      menu.click();
      // menu.firstChild.classList.remove("active");
      // menu.classList.remove("show");
    },
  },
};
</script>
